import Seo from "@/lib/seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion/Reveal";
import { useSite } from "@/hooks/content";

export default function Terms() {
  const { site } = useSite();

  return (
    <>
      <Seo title="Terms of Use" description="Terms of Use for the SKY Training & Consultancy Pte Ltd website." path="/terms-of-use" />
      <PageHero eyebrow="Legal" title="Terms of Use" breadcrumb={[{ name: "Home", path: "/" }, { name: "Terms of Use", path: "/terms-of-use" }]} />
      <section className="section-pad">
        <div className="container-sky max-w-3xl">
          <Reveal>
            <div className="space-y-6 text-sm leading-relaxed text-slate-700 sm:text-base">
              <p>These Terms of Use govern your use of the {site.name} website. This is a placeholder document and should be reviewed and finalised before launch.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Use of Website</h2>
              <p>The content on this website is provided for general information about our consultancy and training services. It does not constitute professional, legal or compliance advice.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Intellectual Property</h2>
              <p>All content, branding and materials on this website are the property of {site.name} unless otherwise stated.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Limitation of Liability</h2>
              <p>While we aim to keep information accurate and up to date, we make no warranties regarding completeness or accuracy of website content.</p>
              <h2 className="font-heading text-xl font-bold text-navy">Contact</h2>
              <p>For any queries regarding these terms, contact us at {site.email} or {site.mobile}.</p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
